export const SUIT = ['s', 'c', 'd', 'h'];
export const CARD = ["AA", "2", "3", "4", "5", "6", "7", "8", "9", "T", "J", "Q", "K", "A"];
export const RANKS = [
	{id: 12,	score: 4000,	num:5,	name: 	'royal-flush',		bestScore: 4000},
	{id: 61,	score: 4000,	num:9,	name:	'all-black'},
	{id: 62,	score: 4000,	num:9,	name:	'all-red'},
	{id: 11,	score: 4000,	num:5,	name: 	'straight-flush'},
	{id: 8,		score: 3000,	num:4,	name:	'four-of-a-kind'},
	{id: 42,	score: 3000,	num:6,	name:	'two-three-of-a-kind',	best: 'AAAKKK'},
	{id: 52,	score: 3000,	num:4,	name: 	'four-straight-flush'},
	{id: 63,	score: 2500,	num:5,	name:	'five-flush-diamonds'},
	{id: 64,	score: 2500,	num:5,	name:	'five-flush-hearts'},
	{id: 65,	score: 2500,	num:5,	name:	'five-flush-spades'},
	{id: 66,	score: 2500,	num:5,	name:	'five-flush-clubs'},
	{id: 21,	score: 2000,	num:6,	name:	'three-pair',			best: 'AAAAKK'},
	{id: 7,		score: 2000,	num:5,	name:	'full-house',			best: 'AAAKK'},
	{id: 6,		score: 2000,	num:5,	name:	'flush'},
	{id: 5,		score: 2500,	num:5,	name:	'straight'},
	{id: 51,	score: 0,		num:3,	name: 	'three-straight-flush'},
	{id: 32,	score: 0,		num:4,	name:	'four-straight'},
	{id: 4,		score: 1000,	num:3,	name:	'three-of-a-kind'},
	{id: 3,		score: 1000,	num:4,	name:	'two-pair',				best: 'AAAA'},

	// {id: 31,	score: 0,	num:3,	name:	'three-straight'},
	// {id: 9,	score: 0,	num:5,	name:	'five-of-a-kind	'},
	// {id: 10,	score: 0,	num:6,	name:	'six-of-a-kind'},
	// {id: 22,	score: 0,	num:8,	name:	'four-pair'},
	// {id: 41,	score: 0,	num:6,	name:	'big-house'},
	{id: 2,		score: 0,	num:2,	name:	'pair'},
	{id: 1,		name: 	'high-hand'}
];
export const DICES = [
	["7s", "3h", "Jd", "5d", "Ac", "9c"],
	["Ah", "4s", "8d", "Xj", "6c", "7h"],
	["5h", "Qd", "Th", "2d", "8c", "Ks"],
	["Qh", "Tc", "Kd", "4c", "9s", "2s"],
	["As", "3c", "9d", "6s", "4d", "Jh"],
	["2c", "3d", "8s", "6h", "Yj", "Qc"],
	["Qs", "7c", "9h", "Kc", "Td", "5s"],
	["Js", "6d", "5c", "Ad", "3s", "4h"],
	["Kh", "Jc", "8h", "Ts", "7d", "2h"]
]
export const getHandName = handId => RANKS.find(v => v.id === handId).name;
export const getGoalCardNum = handId => RANKS.find(v => v.id === handId).num;
export const getCardFace = (cardIndex, suitIndex) => CARD[cardIndex] + SUIT[suitIndex];
const getCard = face => face.slice(0, -1)
//const getSuit = face => face.slice(-1)
export const getDiceFace = cardName => {
	const dice = DICES.findIndex(dice => dice.indexOf(cardName) >= 0);
	const face = DICES[dice].indexOf(cardName)
	return {dice, face}
}
const getCardIndex = face => CARD.indexOf(getCard(face))
const replaceWild = (arr, index, newFace) => {
	const res = arr.map(v => v);
	res.splice(index, 1, newFace);
	return res;
}

const aceIndex = 13, royalIndex = 9;
const SORT = (a,b) => isNaN(a) ? -1 : (isNaN(b) ? 1 : b-a);
const sum = arr => arr.reduce((sum, n) => sum + n, 0)
const decrease = (arr, value, count) => arr.map((v, i) => i === value ? Math.max(v - count, 0) : v)

export function handDetection (faces, goalId, shift = 0) {
	//const goal = window.manager.hands[goalId];
	const goal = getHandName(goalId);
	console.log(logStart(shift), 'CALC INIT =', goal, 'faces =', faces, 'shift =', shift);

	const wildIndex = Math.max(faces.indexOf('Xj'), faces.indexOf('Yj'));
	var results;
	if(wildIndex >= 0) {
		// calc possible replaces depending on goal
		const possibleFaces = getPossibleReplaces(faces, goalId)
		// console.log(logStart(shift), ' wild =', wildIndex, 'poss =', possibleFaces.join(','))

		results = [nonWildDetection(faces.map(v => v), goalId, shift),
		...possibleFaces.map(face => {
			// console.log(logStart(shift+1), '----- replace W at', wildIndex, 'for', face, 'in', faces)
			return handDetection(replaceWild(faces, wildIndex, face), goalId, shift+1)
		})]
	} else {
		if(goalId === 1){	// highest hand
			// console.log(logStart(shift), 'HH faces =', faces, 'R =', RANKS.map(v => v.id))
			for(let i = 0; i < RANKS.length; i++) {
				// console.log(logStart(shift+1), 'try R =', RANKS[i].id, 'G =', RANKS[i].name);
				const res = nonWildDetection(faces.map(v => v), RANKS[i].id, shift+2);
				// console.log(logStart(shift+1), ' get R =', RANKS[i].id, 'ach =', res.goalAchieved);
				if(res.goalAchieved) {
					results = [res];
					break;
				}
			}
		} else
			results = [nonWildDetection(faces, goalId, shift)]
	}
	// console.log(logStart(shift), 'RES FULL =', results.map(r => logResult(r, faces)).join('\n\t\t\t\t'))

	// select final result depending on goal
	const finalRes = selectResult(results, goalId, shift, faces);

	console.log(['%c ', logStart(shift), 'RES F GOAL', goal, 'FINAL ::', logResult(finalRes, faces)].join(' '), `color: ${finalRes.isBest ? 'green' : finalRes.goalAchieved ? 'blue' : 'red'}; ${shift > 0 ? '' : 'font-weight: bold;'}`)
	return finalRes
}
const getPossibleReplaces = (faces, goalId) => {
	var res = [];
	switch(goalId){
		case 	12:		// royal-flush
			res = SUIT.map(s => CARD.slice(royalIndex).map(c => faces.indexOf(c+s) < 0 ? c+s : false)).flat().filter(Boolean);
			break;
		case 	11:		// straight-flush
		case 	51:		// three-straight-flush
		case 	52:		// four-straight-flush
		case 	1:		// high-hand - all cards
			res = SUIT.map(s => CARD.slice(1).reverse().map(c => faces.indexOf(c+s) < 0 ? c+s : false)).flat().filter(Boolean);
			break;
		//case 31:	//	'three-straight',
		case 5:		//	'straight',
		case 32:	//	'four-straight',
			res = CARD.slice(1).map(c => faces.some(v => getCard(v) === c) ? false : c+'s').filter(Boolean);
			break;
		//case 9:	//	'five-of-a-kind'  ,
		//case 10:	//	'six-of-a-kind'   ,
		//case 22:	//	'four-pair',
		//case 41:	//	'big-house',
		case 2:		//	'pair'            ,
		case 3:		//	'two-pair'        ,
		case 4:		//	'three-of-a-kind' ,
		case 7:		//	'full-house'      ,
		case 8:		//	'four-of-a-kind'  ,
		case 21:	//	'three-pair',
		case 42:	//	'two-three-of-a-kind',
			res = CARD.slice(1).reverse().map(c => c + 's' /*SUIT.find(s => faces.indexOf(c + s) === -1)*/);
			break;
		case 6:		//'flush'           ,
			res = SUIT.map(s => CARD.slice(-5).map(c => c + s)).flat();
			break;
		case 62:	//	'all-red',
		case 63:	//	'five-flush-diamonds',
			res = CARD.slice(-5).map(c => c + 'd')
			break;
		case 64:	//	'five-flush-hearts',
			res = CARD.slice(-5).map(c => c + 'h')
			break;
		case 61:	//	'all-black',
		case 65:	//	'five-flush-spades',
			res = CARD.slice(-5).map(c => c + 's')
			break;
		case 66:	//	'five-flush-clubs',
			res = CARD.slice(-5).map(c => c + 'c')
			break;
		default: res = [];
	}
	console.log('7918 \t find replaces :: goal =', getHandName(goalId), 'res =', res)
	return res
}

const selectResult = (results, goalId, shift, faces) => {
	const resFiltered = results.filter(v => !!v.goalAchieved)
	// console.log(logStart(shift), 'RES FILTER =', resFiltered.map(r => logResult(r, faces)).join('\n\t\t\t\t'))

	if(resFiltered.length === 0) 	return results[0]
	if(resFiltered.length === 1) 	return resFiltered[0]
	let res;
	switch(goalId){
		case 2:		//	'pair'            ,
		case 4:		//	'three-of-a-kind' ,
		case 8:		//	'four-of-a-kind'  ,
		case 5:		//	'straight',
		case 32:	//	'four-straight',
		//case 31:	//	'three-straight',
		//case 9:	//	'five-of-a-kind'  ,
		//case 10:	//	'six-of-a-kind'   ,
			res = resFiltered.sort((a, b) => b.winWeight.split('_')[1] - a.winWeight.split('_')[1]);
			break;
		case 	1:		// high-hand 
			console.log(logStart(shift+1), 'HH ranks=', resFiltered.map(v => ~~(v.winWeight.split('_')[0])), 'check =', RANKS.map(v => v.id))
			res = resFiltered.sort((a,b) => {
				const aCards = a.winWeight.split('_').map(v => ~~v);
				const bCards = b.winWeight.split('_').map(v => ~~v);
				const rankA = RANKS.findIndex(v => v.id === aCards[0]);
				const rankB = RANKS.findIndex(v => v.id === bCards[0]);
				if(rankA === rankB) {
					const ind = aCards.findIndex((v, i) => v !== bCards[i]);
					return bCards[ind] - aCards[ind]
				} else 
					return rankA - rankB
			})
			break;
		default: 
			res = resFiltered.sort((a, b) => {
				const aBest = a.isBest, bBest = b.isBest;
				const aCards = a.winWeight.split('_').map(v => ~~v);
				const bCards = b.winWeight.split('_').map(v => ~~v);
				const ind = aCards.findIndex((v, i) => v !== bCards[i]);
				return bBest !== aBest ? bBest - aBest : bCards[ind] - aCards[ind]
			})
	}
	return res[0]

}

const nonWildDetection = (faces, goalId, shift) => {
	const goal = getHandName(goalId);
	console.log(logStart(shift), 'CALC goal =', goal, 'faces =', faces)

	const needStraight = goalId === 5 || goalId === 11 || goalId === 12 || goalId === 31 || goalId === 32 || goalId === 51 || goalId === 52;
	const needFlush = goalId === 6 || goalId === 11 || goalId === 12 || goalId === 51 || goalId === 52 || goalId === 61 || goalId === 62 || goalId === 63 || goalId === 64 || goalId === 65 || goalId === 66;

	// add Ace as 1
	if(needStraight) {
		const aceInd = faces.findIndex(f => getCard(f) === 'A');
		if(aceInd >= 0) {
			faces.push('A' + faces[aceInd]);
			// console.log(logStart(shift), '\t one more ace for :: aces =', aceInd, 'faces =', faces)
		}	
	}

	const parsed = SUIT.map(s => CARD.map(c => faces.filter(v => v === c + s).length)),
		numbers = CARD.map((c, i) => SUIT.reduce((sum, s, j) => sum + parsed[j][i], 0))
	// console.log(logStart(shift), 'PARSED :: p =', parsed, 'logged = \n', '\t'.repeat(shift+1), getLog(parsed, shift), '\n', '\t'.repeat(shift), 'ns =', numbers.join('  '))

	let result = {diceIndices: [],  isBest: false, winWeight: -1, goalAchieved: false};
	let count, goalAchieved = false, suit = -1;
	switch(goalId){
		//case 2:		//	'pair'            ,
		case 4:		//	'three-of-a-kind' ,
		case 8:		//	'four-of-a-kind'  ,
		//case 9:		//	'five-of-a-kind'  ,
		//case 10:	//	'six-of-a-kind'   ,
			count = goalId === 2 ? 2 : goalId === 4 ? 3 :goalId === 8 ? 4 : goalId === 9 ? 5 : 6;
			const top = checkOak(numbers, count).pop();
			//// console.log(logStart(shift), '\t cou =', count, 'oak =', oak, 'top =', top)
			if(top)
				result = {goalAchieved: true, 
					isBest: top === aceIndex, 
					winWeight: getWinWeight(goalId, [top], shift), 
					diceIndices: findValueDice(faces, top, count, shift+1)
				}
			break;
		case 3:		//	'two-pair'        ,
		case 7:		//	'full-house'      ,
		case 42:	//	'two-three-of-a-kind',
		case 21:	//	'three-pair',
		//case 22:	//	'four-pair',
		//case 41:	//	'big-house',
			const counts = goalId === 42 ? [3,3] : 
							goalId === 7 ? [3,2] : 
							goalId === 22 ? [2,2,2,2] : 
							goalId === 21 ? [2,2,2] : 
							[2,2];
			const cards = combo(numbers, counts);
			// console.log(logStart(shift), '\t cou =', counts, 'cards =', cards);
			if(cards.length === counts.length) {
				const bestStr = RANKS.find(v => v.id === goalId).best;
				const cardStr = cards.map((v, i) => CARD[v].repeat(counts[i])).join('')
				 console.log(logStart(shift+1), 'cards =', cards, 'str =', cardStr, 'b =', bestStr);
				result = {goalAchieved: true, 
					isBest: cardStr === bestStr, 
					winWeight: getWinWeight(goalId, cards, shift), 
					diceIndices: findComboDices(faces, cards, counts, shift+1)
				}
			}
			break;
		case 62:	//	'all-red',
		case 61:	//	'all-black',
			const totalColor = sum((goalId === 61 ? [0, 1] : [2,3]).map(si => parsed[si]).flat())
			// console.log(logStart(shift), 'total =', totalColor, 'in =', Array.from(new Array(9), (v, i) => i), 'b =', checkStraight(numbers), 'w =', faces.map(f => getCardIndex(f)).sort(SORT));
			if(totalColor === 9) {
				result = {goalAchieved: true, 
					diceIndices: Array.from(new Array(9), (v, i) => i),
					isBest: true, 
					winWeight: getWinWeight(goalId, faces.map(f => getCardIndex(f)).sort(SORT), shift), 
				}
			}
			break
		case 6:		//'flush'           ,
		case 65:	//	'five-flush-spades',
		case 66:	//	'five-flush-clubs',
		case 63:	//	'five-flush-diamonds',
		case 64:	//	'five-flush-hearts',
			if(goalId === 6) {
				const suitNumbers = SUIT.map((s, si) => parsed[si]).map(arr => sum(arr))
				suit = checkOak(suitNumbers, 5).pop();
				goalAchieved = !isNaN(suit)
			} else {
				suit = goalId === 65 ? 0 : goalId === 66 ? 1 : goalId === 63 ? 2 : 3;
				goalAchieved = sum(parsed[suit]) >= 5;
			}
			if(goalAchieved) {
				const suitCards = parsed[suit]
				const topCards = suitCards.map((v, i) => v > 0 ? i : 0).filter(Boolean).reverse()
				const topFaces = topCards.map(ci => getCardFace(ci, suit)).flat().slice(0, 5)
				const diceIndices =  topFaces.map(face => faces.map((f, i) => f === face ? i : -1).filter(v => v >= 0)).flat().slice(0, 5)
				// console.log(logStart(shift+1), 'cards =', suitCards, 'cInd =', topCards, 'tf =', topFaces, 'INDI =', diceIndices);
				result = {goalAchieved: true, diceIndices,
					isBest: checkStraight(suitCards) >= royalIndex, 
					winWeight: getWinWeight(goalId, topCards, shift), 
				}
			}
			break;
		case 5:		//	'straight',
		case 11:	// straight-flush
		case 51:	// three-straight-flush
		case 52:	// four-straight-flush
		case 12:	// royal-flush
		case 32:	//	'four-straight',
		//case 31:	//	'three-straight',
			count = (goalId === 31 || goalId === 51) ? 3 : 
				(goalId === 32 || goalId === 52) ? 4 : 5;
			let straightIndex, winSuit, numArr;
			//if(goalId === 31 || goalId === 32 || goalId === 5) {
			if(!needFlush) {
				numArr = numbers.map(v => v)
				straightIndex = checkStraight(numArr, count);
			} else {
				const suitNumbers = SUIT.map((s, si) => parsed[si]).map(arr => checkStraight(arr, count));
				straightIndex = Math.max(...suitNumbers);
				if(straightIndex >= 0) {
					winSuit = suitNumbers.indexOf(straightIndex) ;
					numArr = parsed[winSuit];
				}
			}
			// console.log(logStart(shift), 'str =', straightIndex, 'cou =', count, 'numArr =', numArr);
			if((goalId === 12 && straightIndex === royalIndex) ||
				(goalId !== 12 && straightIndex >= 0)) {
				const cardIndices = numArr.map((v, i) => i >= straightIndex ? i : -1)
					.slice(straightIndex, straightIndex + count).reverse();
				const diceIndices = !needFlush 
					? cardIndices.map(v => findValueDice(faces, v, 1, shift+3)).flat()
					: cardIndices.map(ci => faces.indexOf(getCardFace(ci, winSuit))).flat()
				result = {goalAchieved: true, diceIndices,
					isBest: straightIndex >= royalIndex + 5 - count, 
					winWeight: getWinWeight(goalId, cardIndices, shift), 
				}
			}
			break;
		/* case 	1:		// high-hand - all cards*/
		default: // console.log(logStart(shift), 'unknown hand');
	}

	// fix index of added Ace = 1
	if(needStraight && result.goalAchieved) {
		result.diceIndices = result.diceIndices.map(i => i >= 9 ? faces.indexOf(faces[i].slice(1)) : i)
	}
	// console.log(logStart(shift), 'RESULT =', result )

	return result

}

const combo = (in_arr, in_counts, shift=0) => {
	//// console.log(logStart(shift), '\t\t arr =', in_arr, 'cou =', in_counts);
	let resValues = [], arr = in_arr.map(v => v), counts = in_counts.map(v => v)
	do {
		const count = counts.shift();
		const top = checkOak(arr, count).pop();
		//// console.log(logStart(shift), '\t\t\t cou =', count, 'top =', top, 'cur =', arr.join(','));
		if(top)	{
			resValues.push(top);
			arr = decrease(arr, top, count)
		}
	} while(counts.length > 0) 
	//// console.log(logStart(shift), '\t\t res =', resValues);
	return resValues;
}


const checkOak = (arr, count) => {
	return arr.map((v, i) => v >= count ? i : -1).filter(v => v >= 0)
}
const checkStraight = (arr, count = 5) => {
	const arrStr = arr.map(v => !!v ? '+' : '-').join('');
	const checkStr = '+++++++++++++++++++'.substring(0, count);
	return arrStr.lastIndexOf(checkStr);
}

const findComboDices = (arr, values, counts, shift=0) => {
	let faces = arr.map(v => v);
	const indexes = values.map((c, i) => {
		//// console.log(logStart(shift), '\t i =', i, 'c =', c, 'arr =', faces);
		const indi = findValueDice(faces, c, counts[i], shift+1)
		indi.map(i => faces[i] = '-')
		//// console.log(logStart(shift), '\t-- indi =', indi, 'arr =', faces);
		return indi
	}).flat()
	// console.log(logStart(shift), '-- DICES =', indexes);
	return indexes
}
const findValueDice = (faces, cardIndex, count = 5, shift=0) => {
	// console.log(logStart(shift), 'find in', faces, 'ci =', cardIndex, 'card =', CARD[cardIndex])
	const diceIndices = faces.map((f, i) => getCard(f) === CARD[cardIndex] ? i : -1)
		.filter(v => v >= 0).slice(0, count);
	// console.log(logStart(shift), '-- DICES :: inds =', diceIndices)
	return diceIndices;
}

const getWinFaces = (faces, dices) => dices.map(ind => faces[ind])
const getWinWeight = (id, vals, shift) => [id, ...vals, 3-shift].join('_')

// const getLog = (arr, shift = 0) => arr.map((s, si) => s.map((c, ci) => c ? CARD[ci].repeat(c) + SUIT[si] : '--').join(' ')).join('\n' + '\t'.repeat(shift+1) + ' ')
const logStart = (shift = 0) => '7918' + '\t'.repeat(shift);
const logResult = (res, faces) => [res.goalAchieved ? '+' : '-', 'b =', res.isBest, 'inds =', res.diceIndices, 'faces =', getWinFaces(faces, res.diceIndices).join(','), 'w =', res.winWeight].join(' ')